import { render, staticRenderFns } from "./order-view-tabs-wnm.vue?vue&type=template&id=2c311812&scoped=true&"
import script from "./order-view-tabs-wnm.ts?vue&type=script&lang=ts&"
export * from "./order-view-tabs-wnm.ts?vue&type=script&lang=ts&"
import style0 from "./order-view-tabs-wnm.vue?vue&type=style&index=0&id=2c311812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c311812",
  null
  
)

export default component.exports